import { Helmet } from "react-helmet";
import { Container, Row, Col } from "reactstrap";

import BackIcon from "../../components/BackIcon/BackIcon";
import EditPageForm from "../../components/Form/EditPageForm";

const EditPage = () => {
  return (
    <>
      <Helmet>
        <style>{"body { background-color: lightgray; }"}</style>
      </Helmet>
      <Container>
        <BackIcon />
        <Row>
          <Col>
            <EditPageForm />
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default EditPage;
